import img1 from './img/img1.svg';
import img2 from './img/img2.svg';
import img3 from './img/img3.svg';
import img4 from './img/img4.svg';

export const data = [
  {
    id: 1,
    img: img1,
    title: 'Meet other students',
    text: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima, odio porro nostrum temporibus esse aperiam?',
  },
  {
    id: 2,
    img: img2,
    title: 'Ask questions',
    text: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima, odio porro nostrum temporibus esse aperiam?',
  },
  {
    id: 3,
    img: img3,
    title: 'Get your code evaluated',
    text: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima, odio porro nostrum temporibus esse aperiam?',
  },
  {
    id: 4,
    img: img4,
    title: 'Live coding sessions',
    text: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima, odio porro nostrum temporibus esse aperiam?',
  },
];
